import { array, number, object, ref as external_yup_ref, string } from "yup";
import { DRIVE, STAY } from "../shared/constants.js";
import { DISALLOW_INFANT_INTL_FLIGHT, INFANT_CAPACITY_LIMIT } from "../shared/validation/messages.js";
import { asYupResolverSchema } from "../shared/validation/yup-resolver-schema.js";
import { MULTI_DESTINATION, ONE_WAY } from "./constants.js";
const AIRPORT_ERROR = 'Please enter an airport';
const IDENTICAL_LOCATIONS_ERROR = "Departure and arrival airport can't be the same";
const validation_INFANT_CAPACITY_LIMIT = INFANT_CAPACITY_LIMIT;
function isIntlLocation(location) {
    return 'string' == typeof location?.countryCode && 'US' !== location.countryCode.toUpperCase();
}
function isInfantFound(infantCount) {
    return 'number' == typeof infantCount && infantCount > 0;
}
function isIntlLocationWithInfant(infantCount, location) {
    return isIntlLocation(location) && isInfantFound(infantCount);
}
function handleInfantTravel(formState) {
    const { adults, lapInfants } = this.parent;
    const { flights, tripType } = formState;
    const { startLocation, endLocation } = flights[0];
    if ((tripType.includes(STAY) || tripType.includes(DRIVE)) && (isIntlLocationWithInfant(lapInfants, startLocation) || isIntlLocationWithInfant(lapInfants, endLocation))) return this.createError({
        message: DISALLOW_INFANT_INTL_FLIGHT,
        path: this.path
    });
    if (adults < lapInfants) return this.createError({
        message: validation_INFANT_CAPACITY_LIMIT,
        path: this.path
    });
    return true;
}
function isEmptyObject(val) {
    return null == val || 'object' == typeof val && 0 === Object.keys(val).length;
}
const SCHEMA_OW = object().shape({
    endLocation: object().transform((val)=>isEmptyObject(val) ? void 0 : val).required(AIRPORT_ERROR).test('identical locations', IDENTICAL_LOCATIONS_ERROR, function(val) {
        const ref = this.resolve(external_yup_ref('startLocation'));
        return ref?.id !== val?.id;
    }),
    startDate: string().required(),
    startLocation: object().transform((val)=>isEmptyObject(val) ? void 0 : val).required(AIRPORT_ERROR)
});
const SCHEMA_RT = SCHEMA_OW.concat(object().shape({
    endDate: string().required()
}));
const flightSearchFormSchema = asYupResolverSchema(object({
    flightType: string(),
    flights: array().when('flightType', {
        is: (val)=>val === ONE_WAY || val === MULTI_DESTINATION,
        then: (schema)=>schema.of(SCHEMA_OW),
        otherwise: (schema)=>schema.of(SCHEMA_RT)
    }),
    travelers: object({
        lapInfants: number().test({
            name: 'lapInfants',
            test () {
                return handleInfantTravel.call(this, this.from?.[1]?.value);
            }
        })
    })
}));
const validation = flightSearchFormSchema;
export { AIRPORT_ERROR, IDENTICAL_LOCATIONS_ERROR, validation_INFANT_CAPACITY_LIMIT as INFANT_CAPACITY_LIMIT, validation as default, flightSearchFormSchema };
